var _rect, _rect2, _text, _text2, _rect3, _circle, _text3, _text4, _rect4, _circle2, _text5, _text6, _rect5, _circle3, _text7, _text8, _rect6, _circle4, _text9, _text0, _text1, _rect7, _circle5, _text10, _text11, _text12, _rect8, _circle6, _text13, _text14, _text15, _rect9, _circle7, _text16, _text17, _text18, _rect0, _circle8, _text19, _text20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreManagementControlCentreDashboardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390,
    height: 760,
    viewBox: "0 0 390 760",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore mobile management control centre") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 760,
    rx: 30,
    fill: "#07152A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 388,
    height: 758,
    rx: 29,
    fill: "none",
    stroke: "#284260",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 42,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 1.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    dy: 0
  }, "MANAGEMENT CONTROL CENTRE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 79,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    dy: 0
  }, "Fleet position"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 108,
    width: 164,
    height: 84,
    rx: 17,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 133,
    r: 5,
    fill: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 166,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "48")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 137,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 800,
    letterSpacing: 0.7
  }, "ACTIVE VEHICLES")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 108,
    width: 164,
    height: 84,
    rx: 17,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 133,
    r: 5,
    fill: "#30D6A1"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 166,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "36")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 266,
    y: 137,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 800,
    letterSpacing: 0.7
  }, "SHIFTS TODAY")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 206,
    width: 164,
    height: 84,
    rx: 17,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 231,
    r: 5,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 264,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "03")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 235,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 800,
    letterSpacing: 0.7
  }, "OPEN REVIEWS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 206,
    width: 164,
    height: 84,
    rx: 17,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 231,
    r: 5,
    fill: "#087CFF"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 264,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "96%")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 266,
    y: 235,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 800,
    letterSpacing: 0.7
  }, "EVIDENCE COMPLETE")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 329,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 1.2
  }, "RECENT OPERATIONAL EVENTS")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 350,
    width: 342,
    height: 84,
    rx: 16,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 378,
    r: 6,
    fill: "#30D6A1"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 383,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "FC\u20132047")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 383,
    fill: "#30D6A1",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "Shift active")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 412,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Evidence complete")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 452,
    width: 342,
    height: 84,
    rx: 16,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 480,
    r: 6,
    fill: "#FF2775"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 485,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "FC\u20131092")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 485,
    fill: "#FF2775",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "Fuel review")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 514,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Variance surfaced")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 554,
    width: 342,
    height: 84,
    rx: 16,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 582,
    r: 6,
    fill: "#087CFF"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 587,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "FC\u20133188")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 587,
    fill: "#087CFF",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "Checked out")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 616,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "No visible change")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 674,
    width: 342,
    height: 54,
    rx: 14,
    fill: "#0F2847",
    stroke: "#284260"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 701,
    r: 6,
    fill: "#087CFF"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 705,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 760
  }, "OPEN ORIGINAL EVIDENCE")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 705,
    fill: "#74BDFF",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15
  }, "\u2192")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreManagementControlCentreDashboardMobile);
export default __webpack_public_path__ + "static/media/fleetcore-management-control-centre-dashboard-mobile.e8a891c9a51193a61beb314e5280f55c.svg";
export { ForwardRef as ReactComponent };